// extracted by mini-css-extract-plugin
export default {"row":"IssueRow-module__row--XmR1f"};